import { Box, Button } from "@mui/material";
import { useContext, useEffect, useMemo, useState, memo, useCallback } from "react";
import styles from "./styles.module.css";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";

import SnackBar from "../../../../../components/SnackBar";
import {
  obterFolhas,
  obterVerbas,
} from "../../../../../services/api-esocial.service";
import TablesAnalizar from "../../TablesAnalizar";
import TabsGeneric from "../../../../../components/TabsGeneric";
import { exportExcel } from "../../../../../utils/exportExcelFunction";
import { PreviaInssContext } from "../../../PreviaInssContext";
import Loading from "../../../../../components/Loading";

const VerbasEsocial = memo(({ data }) => {
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  // const [loading, setLoading] = useState(false);
  // const [verbasEsocial, setVerbasEsocial] = useState([]);
  // const [verbasComValores, setVerbasComValores] = useState([]);
  const {dados, loading} = useContext(PreviaInssContext);

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.idEmpresa) return;

      // setLoading(true);
      try {
        // const [verbasEsocialResponse, verbasComValoresResponse] =
        //   await Promise.all([
        //     obterVerbas(data.idEmpresa),
        //     obterFolhas(data.idEmpresa),
        //   ]);

        // setVerbasEsocial(verbasEsocialResponse.verbas || []);
        // setVerbasComValores(verbasComValoresResponse.folha || []);
      } catch (error) {
        console.error(error);
        setObjSnackBar({
          type: "error",
          msg: "Não foi possível carregar os dados",
        });
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, [data?.idEmpresa]);

  const downdloadBtnStyle = useMemo(() => ({
    borderColor: "#18316e",
    color: "#18316e",
    fontSize: "0.7rem",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "scale(1.1)",
      border: "1px solid #18316e",
    },
  }), []);

  // Memoize a função de exportação
  const handleObjectExportExcel = useCallback(async (data, type) => {
    try {
      let object = [];
      let nameFile = "";
      
      switch (type) {
        case "valoresEsocial":
          nameFile = "Verbas eSocial";
          object = data.map((item) => ({
            "Código da Rubrica": item.codigoRubrica,
            "Descrição da Rubrica": item.descricaoRubrica,
            "Início da Validade": new Date(item.inicioValidade),
            "Fim (Calculado) da Validade": new Date(item.inicioValidade),
            "Tipo da Rubrica": item.tipoRubrica,
            "Código da Incidência": item.codigoIncidencia,
            "Descrição da Incidência": item.descricaoIncidencia,
            "Categoria da Incidência": item.categoriaIncidencia,
          }));
          break;
        case "verbasComValores":
          nameFile = "Verbas com Valores";
          object = data.map((item) => ({
            "Período de Apuração": new Date(item.periodoApurado),
            "Id da Tabela de Rubricas": item.idTabelaRubrica,
            "Código da Rubrica": item.codRubrica,
            Descrição: item.descricaoRubrica,
            "Tipo de Rubrica": item.tipoRubrica,
            "Valor da Rubrica": parseFloat(
              item.valorRubrica
                .replace(/[^\d,]/g, "")
                .replace(/\./g, "")
                .replace(/(\d+),(\d{2})/, "$1.$2")
            ) / 100,
            Incidência: item.incidencia,
            "Composição de projeto": item.composicaoProjeto ? "Sim" : "Não",
          }));
          break;
        default:
          throw new Error("Tipo de exportação inválido");
      }

      await exportExcel([object, nameFile]);
    } catch (error) {
      setObjSnackBar({ type: "error", msg: "Erro ao exportar relatório" });
    }
  }, []);

  // Memoize as tabs para evitar recriação desnecessária
  const tabs = useMemo(() => {
    if (loading) return [];

    const tabsConfig = [];
    
    if (dados.verbasEsocial?.length > 0) {
      tabsConfig.push({
        label: "Verbas eSocial",
        tab: (
          <TablesAnalizar
            key="tab-verbas-esocial"
            idEmpresa={data.idEmpresa}
            typeData="valoresEsocial"
            data={dados.verbasEsocial}
            loading={loading}
            complementaryHeader={
              <div className={styles.header__verbas}>
                <Button
                  sx={downdloadBtnStyle}
                  startIcon={<FileDownloadRoundedIcon />}
                  variant="outlined"
                  color="primary"
                  type="button"
                  onClick={() => handleObjectExportExcel(dados.verbasEsocial, "valoresEsocial")}
                >
                  Exportar Relatório
                </Button>
              </div>
            }
          />
        )
      });
    }

    if (dados.verbasComValores?.length > 0) {
      tabsConfig.push({
        label: "Verbas com valores",
        tab: (
          <TablesAnalizar
            key="tab-verbas-valores"
            idEmpresa={data.idEmpresa}
            typeData="verbasComValores"
            data={dados.verbasComValores}
            loading={loading}
            complementaryHeader={
              <div className={styles.header__verbas}>
                <Button
                  sx={downdloadBtnStyle}
                  startIcon={<FileDownloadRoundedIcon />}
                  variant="outlined"
                  color="primary"
                  type="button"
                  onClick={() => handleObjectExportExcel(dados.verbasComValores, "verbasComValores")}
                >
                  Exportar Relatório
                </Button>
              </div>
            }
          />
        )
      });
    }

    return tabsConfig;
  }, [dados.verbasEsocial, dados.verbasComValores, loading, data.idEmpresa, downdloadBtnStyle, handleObjectExportExcel]);

  return (
    <>
      {tabs.length > 0 ? (
        <TabsGeneric tabs={tabs} />
      ) : loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
          <Loading loading={loading} />
        </div>
      ) : null}
      
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
});

export default VerbasEsocial;
